import React from 'react';

const sliderSlide = ({image}) => {
    const styles = {
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 60%'
    }
    
    return <div className={`u-inlineBlock u-width100Percent u-height100Percent`} style={styles}></div>;
}

export default sliderSlide;


// WEBPACK FOOTER //
// ./src/components/Slider/SliderSlide/SliderSlide.js